import mailApi from "./mails"

export default {
    sendInquiryEmail:(data) =>{return mailApi.sendMail(data);}
}